/* "Find Your Fabric" hover-reveal (Issue 3, Aug 2026)
   Progressive enhancement only: finds the "Find Your Fabric" collection-list
   section, and for each tile whose collection handle we recognize, injects a
   one-line "feel" description over the image (revealed via CSS on hover;
   shown as a permanent caption on touch devices — see fabric-hover-
   reveal.css). If a handle isn't in the map (e.g. a fabric tile added later),
   that tile is simply left untouched. */
(function () {
  if (typeof window === 'undefined') return;

  var SECTION_HEADING = 'Find Your Fabric';

  // Keyed by collection handle (from the tile's link URL), not the fabric
  // name shown on the tile, since a collection can be titled differently
  // from its handle (e.g. "Summer Silk Sarees" uses the historical
  // "pure-muslin-silk-sarees" handle).
  var FABRIC_DESCRIPTIONS = {
    'pure-katan-silk-sarees': 'Dense, lustrous, and structured — a drape with real presence.',
    'pure-khaddi-georgette-sarees': 'Feather-light and semi-sheer, with a soft, flowing fall.',
    'pure-moonga-silk-saree': 'Naturally golden, smooth, and cool — a sheen that deepens with age.',
    'handloom-pure-tussar-silk-sarees': 'Textured and matte-gold, with the raw warmth of wild silk.',
    'kora-silk-sarees': 'Airy and structured, catching light at every fold.',
    'tissue-silk-sarees': 'Gossamer-thin and shimmering, woven through with fine zari.',
    'pure-chiniya-silk-saree': 'Fine, smooth, and softly lustrous — gentle against the skin.',
    'cotton-sarees': 'Breathable and matte, effortless for everyday elegance.',
    'pure-muslin-silk-sarees': 'Light as air, cool to wear — silk made for warm days.'
  };

  function findSection() {
    var headings = document.querySelectorAll(
      '#MainContent h1, #MainContent h2, #MainContent h3, #MainContent h4, #MainContent h5'
    );
    for (var i = 0; i < headings.length; i++) {
      if (headings[i].textContent.trim() === SECTION_HEADING) {
        return headings[i].closest('.shopify-section');
      }
    }
    return null;
  }

  function handleFromHref(href) {
    if (!href) return '';
    var path = href.split('?')[0].split('#')[0];
    var parts = path.split('/').filter(Boolean);
    return parts.length ? parts[parts.length - 1] : '';
  }

  function init() {
    var section = findSection();
    if (!section) return;

    var cards = section.querySelectorAll('.collection-card');
    cards.forEach(function (card) {
      var link = card.querySelector('.collection-card__link');
      var imageWrap = card.querySelector('.collection-card__image');
      if (!link || !imageWrap) return;

      var handle = handleFromHref(link.getAttribute('href'));
      var description = FABRIC_DESCRIPTIONS[handle];
      if (!description) return;

      var overlay = document.createElement('div');
      overlay.className = 'hb-fabric-feel';

      var text = document.createElement('p');
      text.className = 'hb-fabric-feel__text';
      text.textContent = description;

      overlay.appendChild(text);
      imageWrap.appendChild(overlay);
      card.classList.add('hb-fabric-feel-enabled');
    });
  }

  function start() {
    setTimeout(init, 100);
  }

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start);
  }
})();
